import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'citationcount',
  standalone: false,
})
export class CitationCountPipe implements PipeTransform {
  citationCount: string[] = [];
  transform(
    desc: string,
    totalCitedCount:
      | number
      | {
          id: string;
          subsequentRefID: string | null;
          citationCount: string;
          citationsTotal: number;
        }[]
  ) {
    if (
      desc.includes('{{totalCitationRefCountPlaceholder}}') &&
      !Array.isArray(totalCitedCount)
    ) {
      return desc.replace(
        '{{totalCitationRefCountPlaceholder}}',
        (totalCitedCount || '').toString()
      );
    } else if (
      desc.includes('{{multipleRefsToDeletePlaceholder}}') &&
      Array.isArray(totalCitedCount)
    ) {
      for (const i of totalCitedCount) {
        this.citationCount.push(i.citationCount);
      }
      return desc.replace(
        '{{multipleRefsToDeletePlaceholder}}',
        this.citationCount.toString()
      );
    }
    return desc;
  }
}
